module.exports = __webpack_public_path__ + "img/bg-login.67776517.jpg";